<template>
    <div>
        <div class="editForm">
            <a-input 
                v-model="country_code" 
                :style="{width:'250px',marginRight:'10px'}" 
                :placeholder="t('setting.countryCode')" 
                allow-clear 
                @press-enter="handlePressEnter"
                @clear="handleInputClear"
            />
            <a-input 
                v-model="country" 
                :style="{width:'250px',marginRight:'10px'}" 
                :placeholder="t('order.country')" 
                allow-clear 
                @press-enter="handlePressEnter"
                @clear="handleInputClear"
            />
            <a-select 
                v-model="enable_flag" 
                :style="{width:'250px',marginRight:'10px'}" 
                :placeholder="t('config.enable')" 
                allow-clear
                @change="handleChangeSelect"
            >
                <a-option :value="1">{{ $t('config.enable2') }}</a-option>
                <a-option :value="0">{{ $t('config.disable') }}</a-option>
            </a-select>
            <a-button type="primary" @click="handle('search')">
                <icon-search size="13" style="marginRight:5px;" />
                {{ $t('base.search') }}
            </a-button>
        </div>
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:tableOperate="{ props }">
                <a-button v-permission="'setting.config.edit'"  type="primary" size="mini" @click="handle('edit',props.record)">
                    <icon-edit size="13" style="marginRight:5px;" />
                    {{ $t('base.edit') }}
                </a-button>
            </template>

            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'enable_flag'">
                    <a-tag :color="props.record.enable_flag == 1? 'green' : 'red' ">{{ props.record.enable_flag_text }}</a-tag>
                </div>
            </template>
        </Table>

        <!--编辑 -->
        <a-modal
            v-model:visible="visible" 
            :width="700"
            draggable
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('base.edit') }}</div> 
            </template>
            <!-- <div class="countryCodeEditMsg">{{ $t('base.tip') }}: {{ $t('setting.countryCodeEditMsg') }}</div> -->
            <a-alert style="margin-bottom:20px;width:660px;font-size:12px;">{{ $t('setting.countryCodeEditMsg') }}</a-alert>
            <Form :form="editForm"></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { BaseApi } from '@/api/BaseApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { useI18n } from 'vue-i18n';
    import { EditForm } from './queryConfig/EditForm.js';

    const { t } = useI18n()

    const visible = ref(false)
    const editForm = reactive(EditForm)
    const rowData = ref(null)
    const country = ref('')
    const country_code = ref('')
    const enable_flag = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
            },
            {
                // title: '国家编码',
                title:t('setting.countryCode'),
                dataIndex: 'country_code',
                key:'country_code',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '国家',
                title:t('order.country'),
                dataIndex: 'country',
                key:'country',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '国家本地化名称',
                title:t('setting.countryLocal'),
                dataIndex: 'country_local',
                key:'country_local',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '是否启用',
                title:t('config.enable'),
                dataIndex: 'enable_flag',
                key:'enable_flag',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            {
                // title: '车架',
                title:t('order.frameNumber'),
                dataIndex: 'attribute1',
                key:'attribute1',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流',
                title:t('order.logistics'),
                dataIndex: 'attribute2',
                key:'attribute2',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '是否欧盟国',
                title:t('config.eu_flag'),
                dataIndex: 'eu_flag_text',
                key:'eu_flag_text',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '语言模板',
                title:t('config.lang'),
                dataIndex: 'lang',
                key:'lang',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '120',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getCountryList()
                break;
            case 'edit':    
                visible.value = true
                rowData.value = row
                editForm.formField.forEach(i=>{
                    editForm.formData[i.key] = row[i.key]
                })
                break;
        }
    }

    const handlePressEnter = ()=>{
        table.value.configs.pagination.current = 1
        getCountryList()
    }

    const handleInputClear = ()=>{
        table.value.configs.pagination.current = 1
        getCountryList()
    }

    const handleChangeSelect = (val)=>{
        console.log(enable_flag.value,'mmmm')
        table.value.configs.pagination.current = 1
        getCountryList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getCountryList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getCountryList()
    }

    // 获取国家列表
    const getCountryList = async ()=>{
        let param = {
            country_code: country_code.value, 
            country: country.value,
            enable_flag: enable_flag.value,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await BaseApi.getInstance().getCountryList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    No:index + 1,
                    ...i,
                    enable_flag_text: i.enable_flag == 1? t('config.enable2') : t('config.disable'),
                    enable_flag: i.enable_flag == 1,
                    eu_flag: i.eu_flag,
                    eu_flag_text: i.eu_flag == 1? t('base.yes') : t('base.no'),
                    lang: i.lang,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 编辑国家编码等属性
    const onBeforeOk = async ()=>{
        if(!editForm.formData.country_local && !editForm.formData.eu_flag && !editForm.formData.lang){
            Message.error(t('setting.inputMsg') + ' ' + t('base.noEmpty'))
            return false
        }
        console.log(editForm.formData,'fff')
        let param = {
            country_code: rowData.value.country_code,
            country: rowData.value.country,
           ...editForm.formData,
           enable_flag:editForm.formData.enable_flag? 1 : 0
        }
        console.log(param,'pppp')
        let res = await BaseApi.getInstance().updateCountryCode(param)
        if(res.code == 0){
            Message.success(t('base.editSuccess'))
            getCountryList()
            return true
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getCountryList()
    })
</script>

<style lang="less" scoped>
.editForm{
    background: #fff;
    padding: 10px 20px;

    .form_btn{
        margin-left: -100px;
    }
}

.countryCodeEditMsg{
    margin: 0 auto 20px;
    width: 80%;
    color: #1890ff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 3px 0;
    font-size:13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ button:focus, button:focus-visible {
    outline: none;
}
</style>